import { useEffect, useState } from "react";
import styles from "./SelfEmployedTVR.module.css";
import { TextField } from "@mui/material";
import {
  familyDetails1,
  familyDetails2,
  familyDetails3,
  familyDetails4,
  familyDetails5,
  residenceFields,
  businessDetails,
  referenceCheck_1,
  referenceCheck_2,
} from "./tvrFields";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import { url } from "../../../../../../../../../../../App";
import Cookies from "js-cookie";
import { useBorrowerContext } from "../../../../../../../../store/borrower-details";

const SelfEmployedTVR = ({ loanID }) => {
  useEffect(() => {
    fetchTVR();
    // eslint-disable-next-line
  }, [loanID]);

  const [residenceDetails, setResidenceDetails] = useState({});
  const [family1Fields, setFamily1Fields] = useState({});
  const [family2Fields, setFamily2Fields] = useState({});
  const [family3Fields, setFamily3Fields] = useState({});
  const [family4Fields, setFamily4Fields] = useState({});
  const [family5Fields, setFamily5Fields] = useState({});
  const [businessFields, setBusinessFields] = useState({});
  const [reference1Fields, setreference1Fields] = useState({});
  const [reference2Fields, setreference2Fields] = useState({});
  const { borrowerData } = useBorrowerContext();
  const fetchedLoanDetails = borrowerData.loan;
  const foundLoan = fetchedLoanDetails.find((item) => item.loan_id === loanID);
  const [isDisbursed, setIsDisbursed] = useState(false);

  useEffect(() => {
    if (loanID) {
      setIsDisbursed(foundLoan?.loan_status === "DISBURSED");
    }
    //eslint-disable-next-line
  }, [foundLoan]);

  const fetchTVR = async () => {
    try {
      const request = {
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
        loan_id: loanID,
      };

      const { data: tvrDetails } = await axios.post(url + "/tvr/view", request);
      console.log(tvrDetails.message.borrower_nature_of_business);
      residenceFields.forEach((field) => {
        setResidenceDetails((prevStates) => ({
          ...prevStates,
          [field.state]: tvrDetails.message[field.apiName],
        }));
      });
      businessDetails.forEach((field) => {
        setBusinessFields((prevState) => ({
          ...prevState,
          [field.state]: tvrDetails.message[field.apiName],
        }));
      });

      referenceCheck_1.forEach((field) => {
        setreference1Fields((prevState) => ({
          ...prevState,
          [field.state]: tvrDetails.message[field.apiName],
        }));
      });

      referenceCheck_2.forEach((field) => {
        setreference2Fields((prevState) => ({
          ...prevState,
          [field.state]: tvrDetails.message[field.apiName],
        }));
      });

      setFamily1Fields((prevState) => ({
        ...prevState,
        ...(tvrDetails.message?.family_details && {
          family1Name: tvrDetails.message?.family_details[0]?.family1Name,
        }),
        ...(tvrDetails.message?.family_details && {
          family1Relation:
            tvrDetails.message?.family_details[0]?.family1Relation,
        }),
        ...(tvrDetails.message?.family_details && {
          family1Age: tvrDetails.message?.family_details[0]?.family1Age,
        }),
        ...(tvrDetails.message?.family_details && {
          family1Occupation:
            tvrDetails.message?.family_details[0]?.family1Occupation,
        }),
        ...(tvrDetails.message?.family_details && {
          family1MonthlyIncome:
            tvrDetails.message?.family_details[0]?.family1MonthlyIncome,
        }),
        ...(tvrDetails.message?.family_details && {
          family1LoansTaken:
            tvrDetails.message?.family_details[0]?.family1LoansTaken,
        }),
      }));

      setFamily2Fields((prevState) => ({
        ...prevState,
        ...(tvrDetails.message?.family_details && {
          family2Name: tvrDetails.message?.family_details[1]?.family2Name,
        }),
        ...(tvrDetails.message?.family_details && {
          family2Relation:
            tvrDetails.message?.family_details[1]?.family2Relation,
        }),
        ...(tvrDetails.message?.family_details && {
          family2Age: tvrDetails.message?.family_details[1]?.family2Age,
        }),
        ...(tvrDetails.message?.family_details && {
          family2Occupation:
            tvrDetails.message?.family_details[1]?.family2Occupation,
        }),
        ...(tvrDetails.message?.family_details && {
          family2MonthlyIncome:
            tvrDetails.message?.family_details[1]?.family2MonthlyIncome,
        }),
        ...(tvrDetails.message?.family_details && {
          family2LoansTaken:
            tvrDetails.message?.family_details[1]?.family2LoansTaken,
        }),
      }));

      setFamily3Fields((prevState) => ({
        ...prevState,
        ...(tvrDetails.message?.family_details && {
          family3Name: tvrDetails.message?.family_details[2]?.family3Name,
        }),
        ...(tvrDetails.message?.family_details && {
          family3Relation:
            tvrDetails.message?.family_details[2]?.family3Relation,
        }),
        ...(tvrDetails.message?.family_details && {
          family3Age: tvrDetails.message?.family_details[2]?.family3Age,
        }),
        ...(tvrDetails.message?.family_details && {
          family3Occupation:
            tvrDetails.message?.family_details[2]?.family3Occupation,
        }),
        ...(tvrDetails.message?.family_details && {
          family3MonthlyIncome:
            tvrDetails.message?.family_details[2]?.family3MonthlyIncome,
        }),
        ...(tvrDetails.message?.family_details && {
          family3LoansTaken:
            tvrDetails.message?.family_details[2]?.family3LoansTaken,
        }),
      }));

      setFamily4Fields((prevState) => ({
        ...prevState,
        ...(tvrDetails.message?.family_details && {
          family4Name: tvrDetails.message?.family_details[3]?.family4Name,
        }),
        ...(tvrDetails.message?.family_details && {
          family4Relation:
            tvrDetails.message?.family_details[3]?.family4Relation,
        }),
        ...(tvrDetails.message?.family_details && {
          family4Age: tvrDetails.message?.family_details[3]?.family4Age,
        }),
        ...(tvrDetails.message?.family_details && {
          family4Occupation:
            tvrDetails.message?.family_details[3]?.family4Occupation,
        }),
        ...(tvrDetails.message?.family_details && {
          family4MonthlyIncome:
            tvrDetails.message?.family_details[3]?.family4MonthlyIncome,
        }),
        ...(tvrDetails.message?.family_details && {
          family4LoansTaken:
            tvrDetails.message?.family_details[3]?.family4LoansTaken,
        }),
      }));

      setFamily5Fields((prevState) => ({
        ...prevState,
        ...(tvrDetails.message?.family_details && {
          family5Name: tvrDetails.message?.family_details[4]?.family5Name,
        }),
        ...(tvrDetails.message?.family_details && {
          family5Relation:
            tvrDetails.message?.family_details[4]?.family5Relation,
        }),
        ...(tvrDetails.message?.family_details && {
          family5Age: tvrDetails.message?.family_details[4]?.family5Age,
        }),
        ...(tvrDetails.message?.family_details && {
          family5Occupation:
            tvrDetails.message?.family_details[4]?.family5Occupation,
        }),
        ...(tvrDetails.message?.family_details && {
          family5MonthlyIncome:
            tvrDetails.message?.family_details[4]?.family5MonthlyIncome,
        }),
        ...(tvrDetails.message?.family_details && {
          family5LoansTaken:
            tvrDetails.message?.family_details[4]?.family5LoansTaken,
        }),
      }));
    } catch (err) {
      console.log(err);
    }
  };

  const updateResidenceState = (state) => {
    return (e) => {
      setResidenceDetails((prev) => ({
        ...prev,
        [state]: e.target.value,
      }));
    };
  };

  const updateFamily1States = (state) => {
    return (e) => {
      setFamily1Fields((prevState) => ({
        ...prevState,
        [state]: e.target.value,
      }));
    };
  };

  const updateFamily2States = (state) => {
    return (e) => {
      setFamily2Fields((prevState) => ({
        ...prevState,
        [state]: e.target.value,
      }));
    };
  };

  console.log(residenceDetails);

  const updateFamily3States = (state) => {
    return (e) => {
      setFamily3Fields((prevState) => ({
        ...prevState,
        [state]: e.target.value,
      }));
    };
  };

  const updateFamily4States = (state) => {
    return (e) => {
      setFamily4Fields((prevState) => ({
        ...prevState,
        [state]: e.target.value,
      }));
    };
  };

  const updateFamily5States = (state) => {
    return (e) => {
      setFamily5Fields((prevState) => ({
        ...prevState,
        [state]: e.target.value,
      }));
    };
  };

  const updateBusinessStates = (state) => {
    return (e) => {
      setBusinessFields((prevState) => ({
        ...prevState,
        [state]: e.target.value,
      }));
    };
  };

  const updateReference1States = (state) => {
    return (e) => {
      setreference1Fields((prevState) => ({
        ...prevState,
        [state]: e.target.value,
      }));
    };
  };

  const updateReference2States = (state) => {
    return (e) => {
      setreference2Fields((prevState) => ({
        ...prevState,
        [state]: e.target.value,
      }));
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!loanID) {
      toast.error("Please select a loan.");
      console.log("first");
      return;
    }
    try {
      const request = {
        email: Cookies.get("Email"),
        token: Cookies.get("Token"),
        borrower_uniqueno: localStorage.getItem("uniqueID"),
        loan_id: loanID,
        borrower_current_address: residenceDetails.appCurEddress,
        borrower_permanent_address_years: residenceDetails.parmaAddressYears,
        borrower_current_address_years: residenceDetails.curAddressYears,
        borrower_residence_ownership: residenceDetails.residenceOwnership,
        borrower_residence_ownership_name: residenceDetails.ownerName,
        borrower_residence_ownership_relation:
          residenceDetails.ownerRelationship,
        borrower_residence_landlord_name: residenceDetails.landLordName,
        borrower_residence_rent: residenceDetails.rented,
        borrower_residence_mo_no: residenceDetails.contactNumber,
        borrower_permanent_address: residenceDetails.parmaAddress,
        borrower_requested_loan_amt: businessFields.loanReqAmount,
        borrower_nature_of_business: businessFields.natureOfBusiness,
        borrower_loan_purpose: businessFields.loanPurpose,
        reference_name_1: reference1Fields.ref1name,
        reference_name_2: reference2Fields.ref2name,
        reference_relationship_1: reference1Fields.ref1Relation,
        reference_relationship_2: reference2Fields.ref2Relation,
        reference_customer_do_1: reference1Fields.ref1Occupation,
        reference_customer_do_2: reference2Fields.ref2Occupation,
        reference_number_1: reference1Fields.ref1Number,
        reference_number_2: reference2Fields.ref2Number,
        reference_customer_current_address_1: reference1Fields.ref1CurAddress,
        reference_customer_current_address_2: reference2Fields.ref2CurAddress,
        reference_customer_current_address_years_1:
          reference1Fields.ref1AddressDuration,
        reference_customer_current_address_years_2:
          reference2Fields.ref2AddressDuration,
        reference_customer_permanent_address_1:
          reference1Fields.ref1PermAddress,
        reference_customer_permanent_address_2:
          reference2Fields.ref2PermAddress,
        borrower_business_name: businessFields.nameOfBusiness,
        borrower_business_address: businessFields.addressOfBusiness,
        business_ownership: businessFields.ownershipOfBusiness,
        business_current_address_years: businessFields.businessAddressDuration,
        total_business_vintage: businessFields.businessVintage,
        business_registration_proof:
          businessFields.businessRegistrationProofExist,
        business_previous_address: businessFields.prevAddress,
        monthly_sale: businessFields.monthlySale,
        monthly_profit: businessFields.monthlyProfit,
        affordable_emi: businessFields.affordableEMI,
        borrower_professiontype: "SELF-EMPLOYED",
        family_details: [
          {
            family1Name: family1Fields.family1Name,
            family1Relation: family1Fields.family1Relation,
            family1Age: family1Fields.family1Age,
            family1Occupation: family1Fields.family1Occupation,
            family1MonthlyIncome: family1Fields.family1MonthlyIncome,
            family1LoansTaken: family1Fields.family1LoansTaken,
          },
          {
            family2Name: family2Fields.family2Name,
            family2Relation: family2Fields.family2Relation,
            family2Age: family2Fields.family2Age,
            family2Occupation: family2Fields.family2Occupation,
            family2MonthlyIncome: family2Fields.family2MonthlyIncome,
            family2LoansTaken: family2Fields.family2LoansTaken,
          },
          {
            family3Name: family3Fields.family3Name,
            family3Relation: family3Fields.family3Relation,
            family3Age: family3Fields.family3Age,
            family3Occupation: family3Fields.family3Occupation,
            family3MonthlyIncome: family3Fields.family3MonthlyIncome,
            family3LoansTaken: family3Fields.family3LoansTaken,
          },
          {
            family4Name: family4Fields.family4Name,
            family4Relation: family4Fields.family4Relation,
            family4Age: family4Fields.family4Age,
            family4Occupation: family4Fields.family4Occupation,
            family4MonthlyIncome: family4Fields.family4MonthlyIncome,
            family4LoansTaken: family4Fields.family4LoansTaken,
          },
          {
            family5Name: family5Fields.family5Name,
            family5Relation: family5Fields.family5Relation,
            family5Age: family5Fields.family5Age,
            family5Occupation: family5Fields.family5Occupation,
            family5MonthlyIncome: family5Fields.family5MonthlyIncome,
            family5LoansTaken: family5Fields.family5LoansTaken,
          },
        ],
      };
      console.log(request.borrower_permanent_address_years);
      const { data: response } = await axios.post(url + "/tvr/add", request);
      if (!response.auth) {
        toast.error(response.message);
        return;
      }
      toast.success(response.message);
    } catch (err) {
      toast.error(err.message + "from console");
    }
  };
  console.log(residenceDetails.residenceOwnership);
  return (
    <>
      <ToastContainer />
      <form className={styles.typeBorrower}>
        <h2>Residence Details</h2>
        <div className={styles.borrowerContent}>
          {residenceFields.map((data) =>
            !data.select ? (
              <div className={styles.defaultText} key={data.state}>
                <label htmlFor="" style={{ fontSize: "12px" }}>
                  {data.label}
                </label>
                <TextField
                  type={data.type}
                  value={residenceDetails[data.state]}
                  className={styles.textBox}
                  size="small"
                  onChange={updateResidenceState(data.state)}
                  disabled={isDisbursed}
                />
              </div>
            ) : (
              <div className={styles.defaultText} key={data.state}>
                <label style={{ fontSize: "12px" }}>
                  Ownership Of Residence
                </label>
                <select
                  className={styles.customSelect}
                  value={residenceDetails.residenceOwnership}
                  onChange={updateResidenceState(data.state)}
                  disabled={isDisbursed}
                >
                  {data.selectFields.map((field) => {
                    return (
                      <option key={field.name} value={field.name}>
                        {field.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            )
          )}
        </div>
        <h2>Family Details</h2>
        <h3 style={{ marginTop: "1vh" }}>Member 1</h3>
        <div className={styles.familyDetails}>
          {familyDetails1.map((field) => {
            return (
              <div className={styles.defaultText} key={field.state}>
                <label style={{ fontSize: "12px" }} htmlFor="">
                  {field.label} *
                </label>
                <TextField
                  type={field.type ?? "text"}
                  value={family1Fields[field.state]}
                  onChange={updateFamily1States(field.state)}
                  size="small"
                  className={styles.textBox}
                  disabled={isDisbursed}
                />
              </div>
            );
          })}
        </div>
        <h3 style={{ marginTop: "1vh" }}>Member 2</h3>
        <div className={styles.familyDetails}>
          {familyDetails2.map((field) => {
            return (
              <div className={styles.defaultText} key={field.state}>
                <label style={{ fontSize: "12px" }} htmlFor="">
                  {field.label} *
                </label>
                <TextField
                  type={field.type ?? "text"}
                  required
                  value={family2Fields[field.state]}
                  onChange={updateFamily2States(field.state)}
                  className={styles.textBox}
                  size="small"
                  disabled={isDisbursed}
                />
              </div>
            );
          })}
        </div>
        <h3 style={{ marginTop: "1vh" }}>Member 3</h3>
        <div className={styles.familyDetails}>
          {familyDetails3.map((field) => {
            return (
              <div className={styles.defaultText} key={field.state}>
                <label style={{ fontSize: "12px" }} htmlFor="">
                  {field.label} *
                </label>
                <TextField
                  type={field.type ?? "text"}
                  className={styles.textBox}
                  value={family3Fields[field.state]}
                  onChange={updateFamily3States(field.state)}
                  size="small"
                  disabled={isDisbursed}
                />
              </div>
            );
          })}
        </div>
        <h3 style={{ marginTop: "1vh" }}>Member 4</h3>
        <div className={styles.familyDetails}>
          {familyDetails4.map((field) => {
            return (
              <div className={styles.defaultText} key={field.state}>
                <label style={{ fontSize: "12px" }} htmlFor="">
                  {field.label}
                </label>
                <TextField
                  className={styles.textBox}
                  value={family4Fields[field.state]}
                  type={field.type ?? "text"}
                  onChange={updateFamily4States(field.state)}
                  size="small"
                  disabled={isDisbursed}
                />
              </div>
            );
          })}
        </div>
        <h3 style={{ marginTop: "1vh" }}>Member 5</h3>
        <div className={styles.familyDetails}>
          {familyDetails5.map((field) => {
            return (
              <div className={styles.defaultText} key={field.state}>
                <label style={{ fontSize: "12px" }} htmlFor="">
                  {field.label}
                </label>
                <TextField
                  type={field.type ?? "text"}
                  value={family5Fields[field.state]}
                  onChange={updateFamily5States(field.state)}
                  className={styles.textBox}
                  size="small"
                  disabled={isDisbursed}
                />
              </div>
            );
          })}
        </div>
        <h2>Business Details</h2>
        <div className={styles.borrowerContent}>
          {businessDetails.map((data) =>
            !data.select ? (
              <div className={styles.defaultText} key={data.state}>
                <label style={{ fontSize: "12px" }} htmlFor="">
                  {data.label} *
                </label>
                <TextField
                  type={data.type ?? "text"}
                  value={businessFields[data.state]}
                  onChange={updateBusinessStates(data.state)}
                  className={styles.textBox}
                  size="small"
                  disabled={isDisbursed}
                />
              </div>
            ) : (
              <div className={styles.defaultText} key={data.state}>
                <label style={{ fontSize: "12px" }}>{data.label}*</label>
                <select
                  className={styles.customSelect}
                  value={businessFields[data.state]}
                  onChange={updateBusinessStates(data.state)}
                  disabled={isDisbursed}
                >
                  {data.selectFields.map((field) => {
                    return (
                      <option
                        key={field.val ?? field}
                        value={field.val ?? field}
                      >
                        {field.name ?? field}
                      </option>
                    );
                  })}
                </select>
              </div>
            )
          )}
        </div>
        <h2>Reference Details</h2>
        <h3>Reference 1</h3>
        <div className={styles.borrowerContent}>
          {referenceCheck_1.map((field, index) => {
            return (
              <div className={styles.defaultText} key={index}>
                <label style={{ fontSize: "12px" }} htmlFor="">
                  {field.label} *
                </label>
                <TextField
                  type={field.type ?? "text"}
                  value={reference1Fields[field.state]}
                  onChange={updateReference1States(field.state)}
                  placeholder={field.placeholeder}
                  size="small"
                  className={styles.textBox}
                  disabled={isDisbursed}
                />
              </div>
            );
          })}
        </div>
        <h3>Reference 2</h3>
        <div className={styles.borrowerContent}>
          {referenceCheck_2.map((field, index) => {
            return (
              <div className={styles.defaultText} key={index}>
                <label style={{ fontSize: "12px" }} htmlFor="">
                  {field.label} *
                </label>
                <TextField
                  type={field.type ?? "text"}
                  value={reference2Fields[field.state]}
                  onChange={updateReference2States(field.state)}
                  size="small"
                  className={styles.textBox}
                  disabled={isDisbursed}
                />
              </div>
            );
          })}
        </div>
        <div className={styles.tvrSubmit}>
          <button onClick={handleSubmit} disabled={isDisbursed}>
            SUBMIT
          </button>
        </div>
      </form>
    </>
  );
};

export default SelfEmployedTVR;
